export default function getData(listing, derivedprice, rating, url) {
  if (listing === void 0) {
    listing = {};
  }
  if (derivedprice === void 0) {
    derivedprice = {};
  }
  if (rating === void 0) {
    rating = {};
  }
  const {
    images,
    make,
    model
  } = listing;
  let aggregateRating = null;
  if (rating.value && rating.count) {
    aggregateRating = {
      '@context': 'http://schema.org/',
      '@type': 'AggregateRating',
      bestRating: '5',
      worstRating: '1',
      ratingValue: rating.value,
      ratingCount: rating.count
    };
  }
  return {
    '@context': 'http://schema.org/',
    '@type': ['Vehicle', 'Product'],
    name: `${make.name} ${model.name}`,
    image: images?.sources?.[0]?.src || '',
    url,
    offers: {
      '@context': 'http://schema.org/',
      '@type': 'Offer',
      priceSpecification: {
        '@context': 'http://schema.org/',
        '@type': 'PriceSpecification',
        priceCurrency: 'USD',
        price: Math.floor(derivedprice.average),
        minPrice: derivedprice.min,
        maxPrice: derivedprice.max
      }
    },
    ...(aggregateRating && {
      aggregateRating
    })
  };
}